import React from "react";
import { Helmet } from "react-helmet";
import '../../styles/lyrics.css';

const OhMyGaush = () => {
  return (
    <div>
      <Helmet>
        <title>LYRICS - OH MY GAUSH</title>
      </Helmet>

      <section class="lyrics-catalog">
        <p style={{fontSize: '50px', color: '#ffffff', lineHeight: '90%', marginBottom: '60px'}}>LYRICS - OH MY GAUSH</p>
        <div class="lyrics-frames">
        <div class="lyrics">
                [Chorus]<br/>
                Oh my gaush<br/>
                My gosh, oh my gaush<br/>
                Stage pe jab utru toh ho mics drop<br/>
                All lights on<br/>
                My gosh, oh my Gaush<br/>
                Ye ladkiya chillarahi oh my Gaush<br/>
                Wanna hold my nuts<br/>
                <br/>
                [Verse 1]<br/>
                Diss game me mera naam kidhar tha?<br/>
                Pehele din se malum, mai na mamuli ladka<br/>
                Bachpan se seekha hai sabse, aapasi jhagde tumhaare mai sulja nai sakta<br/>
                Baaki label thukraake, BR sign kara mai wo karta nai bro agar jhaat pe rakhta<br/>
                KR LO$A SIGN kara ghost write nahi magar shukriya bro, mujhe kaabil samjha<br/>
                Mai nahi kar raha kisi ko diss<br/>
                Naam aaya beech, it is what it is<br/>
                Ho rakha viral mai, how can I miss?<br/>
                Thanks for the promo, I take no offence<br/>
                In jaise se sekdo, aur hum jaise 1-2 tum chahe jo kehdo<br/>
                Do not give a shit<br/>
                Pehele se mai toh feel kar raha like J cole, &quot;They act like 2 legends cannot co-exist&quot;
                (Damn)<br/>
                I ain't into beefing and all of that<br/>
                Fir bhi chaiye toh mil jana on the map<br/>
                Log banrahe stans ab mere I'm leaving autographs on their Starter Caps<br/>
                Mat bulana next whoever, mai pehela is lane me take it for a fact<br/>
                The only time that I ghost is when I fuck a bitch and I don't ever call her back<br/>
                <br/>
                [Chorus]<br/>
                Oh my gaush<br/>
                My gosh, oh my gaush<br/>
                Stage pe jab utru toh ho mics drop<br/>
                All lights on<br/>
                My gosh, oh my gaush<br/>
                Ye ladkiya chillarahi oh my gaush<br/>
                Wanna hold my nuts<br/>
                <br/>
                Oh my gaush<br/>
                My gosh, oh my gaush<br/>
                Stage pe jab utru toh ho mics drop<br/>
                All lights on<br/>
                My gosh, oh my gaush<br/>
                Ye ladkiya chillarahi oh my gaush<br/>
                Wanna hold my nuts<br/>
                <br/>
                [Verse 2]<br/>
                You cross and jeez us/Jesus you get crucified<br/>
                And I can see the suicidal youth in eyes/ euthanized<br/>
                Of me and you surviving living in my shadow<br/>
                Dhundhe rappers saaya<br/>
                I'm the Rap Messiah<br/>
                Kara stack up higher, no one close to me<br/>
                Leave 'em choked really jo kare smoke with G<br/>
                People change, different coloured shades, I'mma put 'em in their place, no OCD<br/>
                GAUSH level kabhi choo bhi nai paate wo<br/>
                Khauf me wo bohot sade par wo door khade kaafi<br/>
                Oh Lord, I'm the prodigy brother you couldn't stop me<br/>
                Are y'all sending shots like I ain't got shooters around me<br/>
                Their confidence dropping, I tie a noose to your body<br/>
                Get locked in a coffin, like I'm a true Shinigami<br/>
                You spar, you can (Ryuk) not beat the fucking hugest of armies<br/>
                Na kare jhoothe dikhaawe hai kara prove that I'm Godly you little bitch<br/>
                <br/>
                [Chorus]<br/>
                Oh my gaush<br/>
                My gosh, oh my gaush<br/>
                Stage pe jab utru toh ho mics drop<br/>
                All lights on<br/>
                My gosh, oh my gaush<br/>
                Ye ladkiya chillarahi oh my gaush<br/>
                Wanna hold my nuts<br/>
                <br/>
                [Verse 3]<br/>
                Bura waqt me ye puchne kyu aate nai haal<br/>
                Mahino door raha game se, nahi ladaate jubaan<br/>
                Apni tarakki dekh ke ye chadne aate gawaar<br/>
                Kabhi bhi daga nai diye kisi ko, maanle baat<br/>
                Akele khada tu fir scene me, toh fir dengey nai bhaav<br/>
                Naqaab pehene they apan par dikhe chehre ye saaf<br/>
                De dengey vaar, kar rahe saajishe mere khilaaf<br/>
                Area ke bahar kabhi aa mil tu, le lengey jaan<br/>
                Business me dikhe sirf facades<br/>
                Kara dismiss mai kitne aise kaam<br/>
                Ain't no snitch shit, up in this bitch baate hazaar<br/>
                I'm relentless I never quit, maante nai haar<br/>
                On my hitlist, aakhri wish maangle tu aaj<br/>
                Aur thok do jahape<br/>
                Khoj lo wahape<br/>
                Bohot kholte raaz ye<br/>
                Dostlog ke baare<br/>
                Oh no, ye saare<br/>
                Log dhokebaaz hai<br/>
                Smoking these enemies<br/>
                Sale chehre pe dikhe mujhe ab bohot inki jealousy<br/>
                Jaan booj ke kare ungli, hoping it's gets to me<br/>
                Chod diya mai jeena jindagi logo ke kehne se<br/>
                Gaane sunke hasu inke: joking, you better be<br/>
                Chahte kaafi par kabhi dikhe na wo meri jageh pe<br/>
                Laga jor tu jitna, kabhi rok nai sake ye<br/>
                G.O.A.T hoon mai legendary<br/>
                On the epitome<br/>
                Something you'd never be<br/>
                <br/>
                [Chorus]<br/>
                Oh my gaush<br/>
                My gosh, oh my gaush<br/>
                Stage pe jab utru toh ho mics drop<br/>
                All lights on<br/>
                My gosh, oh my gaush<br/>
                Ye ladkiya chillarahi oh my gaush<br/>
                Wanna hold my nuts<br/>
                <br/>
                Oh my gaush<br/>
                My gosh, oh my gaush<br/>
                Stage pe jab utru toh ho mics drop<br/>
                All lights on<br/>
                My gosh, oh my gaush<br/>
                Ye ladkiya chillarahi oh my gaush<br/>
                Wanna hold my nuts
            </div>
        </div>
    </section>
      

    </div>
  );
};

export default OhMyGaush;
